module.exports = {"activityPictures":[{"name":"2019 Day 1","imgURL":"2019Day1.JPG","position":"","SNS":"https://photos.app.goo.gl/cUQn5BebwRsyogZo9"},{"name":"2019 Day 2","imgURL":"2019Day2.JPG","position":"","SNS":"https://photos.app.goo.gl/kqMEQTiQiQxe9uj79"},{"name":"2020","imgURL":"2020.JPG","position":"","SNS":"https://photos.app.goo.gl/wGBmTwHpRA1gqLGV8"}]}


//////////////////
// WEBPACK FOOTER
// ./src/App/JsonData/activityPictures.json
// module id = 175
// module chunks = 0